import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Flexbox, Heading, Label, Modal, ModalBody, ModalFooter, ModalHeader, Select, shootToast } from "codekit";

import { useGetCargosAdmpuestQuery } from "../../../libs/redux/slices/Usuarios/Admpuest/admpuestApiSlice";
import { useLazyGetMenuCargoQuery } from "../../../libs/redux/slices/Usuarios/Vercomo/vercomoApiSlice";
import { clearCargoPreview, getCargoPreview, getIsAdmin, getVercomoAbierto, setCargoPreview, setVercomoAbierto } from "../../../libs/redux/slices/authSlice/authSlice";
import { apiSlice } from "../../../libs/redux/slices/apiSlice";
import { Avisoxxx } from "../../Tablerox";

/**
 * "Ver como cargo" (Diego 2026-09-14): la ventana de elección de cargo y la
 * franja del modo, siempre montadas en la página principal. Al elegir un
 * cargo, el menú pasa a ser la plantilla de permisos de ese cargo y toda
 * petición viaja con la cabecera Cargoview: el backend responde con las
 * plantillas de Mi Puesto, del escritorio y del Inicio del cargo, en solo
 * lectura. "Volver a mi vista" restaura el menú propio.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-09-14
 * @param {function} handleClickHome Vuelve al Inicio (limpia módulo y proceso)
 */
const Vercomob = ({ handleClickHome }) => {
  const dispatch = useDispatch();
  const isAdmin = useSelector(getIsAdmin);
  const cargoPreview = useSelector(getCargoPreview);
  const isOpen = useSelector(getVercomoAbierto);
  const [cargo, setCargo] = useState("");
  const { data: cargosData } = useGetCargosAdmpuestQuery(undefined, { skip: !isAdmin });
  const [getMenuCargo, { isLoading }] = useLazyGetMenuCargoQuery();

  if (!isAdmin) {
    return null;
  }
  const cargos = (cargosData?.data ?? []).map((c) => ({ text: `${c.CARIDXXX} - ${c.CARDESXX}`, value: String(c.CARIDXXX) }));
  const cerrar = () => dispatch(setVercomoAbierto(false));

  //Todo el API vuelve a consultarse con la cabecera nueva (o sin ella)
  const reiniciar = () => {
    window.sessionStorage.removeItem("mipuestoAterrizado");
    dispatch(apiSlice.util.resetApiState());
    handleClickHome();
  };

  const handleVer = async () => {
    await getMenuCargo(cargo)
      .unwrap()
      .then((resp) => {
        dispatch(setCargoPreview(resp.data));
        cerrar();
        reiniciar();
      })
      .catch((error) => shootToast({ variant: "error", text: error?.data?.errors?.message ?? "No se pudo cargar el menú del cargo", duration: 4000, autoHide: true }));
  };

  const handleVolver = () => {
    dispatch(clearCargoPreview());
    cerrar();
    reiniciar();
  };

  return (
    <>
      {cargoPreview && (
        <Box mb={3}>
          <Avisoxxx
            tonoxxx="MORADO"
            kicker="Modo de mantenimiento · solo lectura"
            valor={cargoPreview.CARIDXXX}
            titulo={`Estás viendo el sistema como ${cargoPreview.CARDESXX}`}
            texto="Menú, Mi Puesto, escritorio e Inicio con las plantillas de ese cargo. Tus datos y clientes siguen siendo los tuyos; solo puedes guardar en la parametría de puestos."
            acciones={[
              { clave: "volver", texto: "Volver a mi vista", primaria: true, onClick: handleVolver },
              { clave: "otro", texto: "Ver otro cargo", onClick: () => dispatch(setVercomoAbierto(true)) },
            ]}
          />
        </Box>
      )}
      <Modal size="md" isOpen={isOpen}>
        <ModalHeader>
          <Flexbox justifyContent="between" alignItems="center">
            <Heading variant="heading-5" color="primary-700">Ver el sistema como un cargo</Heading>
            <Button variant="secondary" icon="close" onlyIcon size="m" onClick={cerrar} />
          </Flexbox>
        </ModalHeader>
        <ModalBody size="sm">
          <Label>Cargo</Label>
          <Select value={cargo} options={[{ text: "Elige un cargo", value: "" }, ...cargos]} onChangeValue={(context) => setCargo(String(context.option.value))} />
          <Box mt={3}>
            <Label color="neutral-500">Verás el menú, Mi Puesto, el escritorio y el Inicio con las plantillas de ese cargo, en solo lectura. Tus datos y tus clientes siguen siendo los tuyos.</Label>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flexbox justifyContent="between" alignItems="center" gap={4}>
            {cargoPreview ? <Button type="button" variant="secondary" size="2l" onClick={handleVolver}>Volver a mi vista</Button> : <span />}
            <Button type="button" variant="primary-bold" size="2l" minWidth={160} isLoading={isLoading} disabled={!cargo} onClick={handleVer}>Ver como este cargo</Button>
          </Flexbox>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Vercomob;
